import { Component, ViewEncapsulation, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/index';

@Component({
    selector: 'app-paginator',
    templateUrl: './paginator.component.html',
})
export class PaginatorComponent implements OnInit {
    // @Input() total: number;
    @Input() current: number;
    @Output() currentChange = new EventEmitter();

    @Input() itemsShow: number;

    private _total: number;
    get total(): number {
        // transform value for display
        return this._total;
    }

    @Input()
    set total(total: number) {
        // console.log('prev value: ', this._total);
        // console.log('got total: ', total);

        if (total || total === 0) {
            this._total = total;
            this.calculatePagination();
        }
    }

    itemPaginators: Array<any>;

    constructor(private store: Store<AppState>) {}

    ngOnInit() {
        this.calculatePagination();
    }

    calculatePagination() {
        const current: number = this.current || 1;
        const last: number = this.total;
        const delta: number = this.itemsShow || 2;
        const left: number = current - delta;
        const right: number = current + delta + 1;
        const range: Array<any> = [];
        // const rangeWithDots: Array<any> = [];
        let i: number;
        let l: number;

        this.itemPaginators = [];
        for (i = 1; i <= last; i++) {
            if (i === 1 || i === last || (i >= left && i < right)) {
                range.push(i);
            }
        }

        for (i of range) {
            if (l) {
                if (i - l === 2) {
                    this.itemPaginators.push(l + 1);
                } else if (i - l !== 1) {
                    this.itemPaginators.push('...');
                }
            }
            this.itemPaginators.push(i);
            l = i;
        }
    }

    clickItemPage(ev, page) {
        ev.preventDefault();

        if (isNaN(page)) {
            return;
        }

        this.current = page;
        this.updateCurrent();
    }

    clickPrev(ev) {
        ev.preventDefault();

        if (this.current > 1) {
            this.current--;
            this.updateCurrent();
        }
    }

    clickNext(ev) {
        ev.preventDefault();

        if (this.current < this.total) {
            this.current++;
            this.updateCurrent();
        }
    }

    updateCurrent() {
        // this.currentChange.emit(this.current);
        this.calculatePagination();
        this.currentChange.emit({ page: this.current });
    }
}
